import type { Component } from "svelte";
import IconCash100 from '~icons/mdi/cash-100';
import IconCreditCard from '~icons/mdi/credit-card';
import IconDiamondStone from '~icons/mdi/diamond-stone';
import IconTicketPercent from '~icons/mdi/ticket-percent';

export enum CostLevel {
    FREE = 'FREE',
    BUDGET = 'BUDGET',
    MODERATE = 'MODERATE',
    LUXURY = 'LUXURY',
}

export const COST_LEVEL_ICONS: Record<CostLevel, Component> = {
    [CostLevel.FREE]: IconTicketPercent,
    [CostLevel.BUDGET]: IconCash100,
    [CostLevel.MODERATE]: IconCreditCard,
    [CostLevel.LUXURY]: IconDiamondStone,
};